import { AppToaster } from "@components/AppToaster";
import { OrgData } from "@types";
import { withToaster } from "@utils";

import { savePolicy } from "../api";
import { PolicyWithRules } from "../types";

/**
 * Saves changes to a policy in the backend
 */
export const onUpdatePolicy =
  (
    org: OrgData,
    policy: PolicyWithRules,
    setIsSaving: (isSaving: boolean) => void,
    setStashed: (policy?: PolicyWithRules) => void,
    refreshPolicies: () => void
  ) =>
  async () => {
    if (policy === undefined) {
      return;
    }
    setIsSaving(true);
    try {
      await withToaster(
        async () => {
          await savePolicy(org.id, policy);
          setStashed(undefined);
          AppToaster.show({
            message: `Policy saved.`,
            intent: "success",
          });
        },
        (err) => `Error saving policy: ${err.body?.error}`
      )();
    } finally {
      await refreshPolicies();
      setIsSaving(false);
    }
  };
